<script setup lang="ts">
import { linkGoOrder } from '@/event/basket/linkGoOrder'
import {
    showAlertAuthBasket,
    showAlertAuthBasketTransition
} from '@/happyTheme/event/modalBasket/showAlertValidateBasket'
import { toggleShowModalBasketHappy } from '@/happyTheme/utils/modalBasket/toggleShowModalBasketHappy'

function toggleShowAuthBasketHappy() {
    showAlertAuthBasketTransition.value = false
    setTimeout(() => {
        showAlertAuthBasket.value = !showAlertAuthBasket.value
    }, 300)
}
function toggleLoginBasketHappy() {
    linkGoOrder.value = true
    setTimeout(() => {
        showAlertAuthBasketTransition.value = false
        setTimeout(() => {
            showAlertAuthBasket.value = !showAlertAuthBasket.value
            toggleShowModalBasketHappy()
        }, 300)
    }, 300)
}

function toggleRegisterBasketHappy() {
    setTimeout(() => {
        showAlertAuthBasketTransition.value = false
        setTimeout(() => {
            showAlertAuthBasket.value = !showAlertAuthBasket.value
            toggleShowModalBasketHappy()
        }, 300)
    }, 300)
}
</script>

<template>
    <section class="section-alert-validate-basket-happy">
        <section
            class="section-alert-validate-basket-overlay-happy"
            @click="toggleShowAuthBasketHappy()"
        ></section>

        <transition
            name="basket-alert-auth"
            enter-active-class="transition-transform duration-300 ease-out"
            enter-from-class="-translate-y-full"
            enter-to-class="translate-y-0"
            leave-active-class="transition-transform duration-300 ease-out"
            leave-from-class="translate-y-0"
            leave-to-class="-translate-y-full"
        >
            <section
                class="section-alert-validate-basket-content-happy"
                v-if="showAlertAuthBasketTransition"
            >
                <div class="div-cross-alert-auth-basket-happy">
                    <svg
                        @click="toggleShowAuthBasketHappy()"
                        class="svg-cross-alert-auth-basket-happy"
                        viewBox="0 0 30 30"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M23.75 6.25L6.25 23.75M6.25004 6.25L23.75 23.75"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>

                <div class="div-content-alert-auth-basket-happy">
                    <p class="text-center font-semibold">
                        Vous devez être connecté pour commander
                    </p>
                    <div class="div-button-alert-auth-basket-happy">
                        <router-link
                            :to="{ name: 'login' }"
                            @click="toggleLoginBasketHappy()"
                            class="button-alert-connexion-basket-happy"
                        >
                            Connexion
                        </router-link>
                        <router-link
                            :to="{ name: 'register' }"
                            @click="toggleRegisterBasketHappy()"
                            class="button-alert-register-basket-happy"
                        >
                            S'inscrire
                        </router-link>
                    </div>
                </div>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-alert-validate-basket-happy {
    @apply absolute inset-0 z-30 h-full w-full flex items-center justify-center;
}
.section-alert-validate-basket-overlay-happy {
    @apply w-full h-full relative;
}
.section-alert-validate-basket-content-happy {
    @apply absolute w-80 overflow-hidden bg-border-red-happy-light z-30 flex flex-col items-center flex-wrap justify-center rounded-xl  pt-3 gap-3;
}
.div-cross-alert-auth-basket-happy {
    @apply w-full flex justify-end items-center px-3;
}
.h3-alert-auth-basket-happy {
    @apply font-semibold text-lg;
}

.svg-cross-alert-auth-basket-happy {
    @apply w-8 h-8 cursor-pointer stroke-bg-happy-light;
    @apply transition-all duration-150 ease-out;
}
.svg-cross-alert-auth-basket-happy:active,
.svg-cross-alert-auth-basket-happy:focus {
    @apply scale-110 stroke-text-dark-happy-light;
}

.div-content-alert-auth-basket-happy {
    @apply flex flex-col items-center gap-1 bg-header-red-happy pt-3;
}

.div-button-alert-auth-basket-happy {
    @apply flex flex-col w-full justify-between p-3 gap-1;
}

.button-alert-connexion-basket-happy {
    @apply bg-button-yellow-happy-light text-center text-text-dark-happy-light font-semibold rounded-lg p-2 w-full shadow shadow-text-dark-happy-light;
}
.button-alert-connexion-basket-happy:active,
.button-alert-connexion-basket-happy:focus {
    @apply bg-hover-yellow-happy;
}

.button-alert-register-basket-happy {
    @apply bg-bg-happy-light text-text-dark-happy-light font-semibold rounded-lg p-2 w-full text-center  shadow shadow-text-dark-happy-light;
}
.button-alert-register-basket-happy:active,
.button-alert-register-basket-happy:focus {
    @apply bg-border-gray-happy-light;
}

@media (hover: hover) {
    .svg-cross-alert-auth-basket-happy:hover {
        @apply scale-110 stroke-text-dark-happy-light;
    }
    .button-alert-connexion-basket-happy:hover {
        @apply bg-hover-yellow-happy;
    }
    .button-alert-register-basket-happy:hover {
        @apply bg-border-gray-happy-light;
    }
}
</style>
